export const NUM_SECTIONS = 5;
export const LOADING_SCREEN_DURATION = 3300;
export const BULLET_ENTRANCE_TRANSITION_DELAY = 1000;
export const BULLET_ENTRANCE_TRANSITION_INTERVAL = 75;
export const TRANSITION_ASSIGNMENT_BUFFER = 100;
export const NOTIFICATION_DURATION = 6000;
export const SCROLL_DURATION = 200;
export const TOOLS = [
  "HTML",
  "CSS",
  "JavaScript",
  "TypeScript",
  "React",
  "Next.js",
  "SASS",
  "Tailwind CSS",
  "Material UI",
  "Jest",
  "React Testing Library",
  "Git",
] as const;
export const SKILLS = [
  "Responsive Web Design",
  "Accessibility",
  "UI/UX Design",
  "Algorithms",
  "Server-side Rendering",
  "Single-page Applications",
  "Test-driven Development",
  "Game Development",
] as const;
